import type { Graph, Thing } from 'schema-dts';
import type { ProductCard } from '@repo/supergraph-schemas/roundup/base/types';
import { LinkedDataJson } from '..';
import { getProductListSchema } from './schema';

export type ProductListDataProps = Graph;

export const ProductListData = ({
  offers,
  id,
  url,
}: {
  offers: ProductCard[];
  id: string;
  url: string;
}) => {
  return <LinkedDataJson<Thing> id={id} schema={getProductListSchema({ offers, url })} />;
};
